import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'
import { createSelector } from '@reduxjs/toolkit'

export const selectIsLoading = (store: StoreSchema) => store.notifications.isLoading

export const selectNotifications = (store: StoreSchema) => store.notifications.notifications
export const selectSubscribers = (store: StoreSchema) => store.notifications.subscribers

export const selectNotificationsWithSubscribers = createSelector(
	[selectNotifications, selectSubscribers],
	(notifications, subscribers) => {
		return notifications.map(notification => ({
			...notification,
			subscribers: subscribers[notification.notificationId] ?? []
		}))
	}
)